import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../../../redux/actions';
import { createOrder, startNetsPayment } from '../../../../utils/api/restClient';

export const usePaymentFlow = ({ project, basket }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [orderReferenceId, setOrderReferenceId] = useState(null);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isSubmitting = useRef(false);

  const handlePayment = async (selectedOption) => {
    if (isSubmitting.current || isProcessing) {
      return;
    }

    isSubmitting.current = true;
    setIsProcessing(true);

    try {

      if (orderReferenceId === null) {
        dispatch(setLoading(true));
        const orderResponse = await createOrder(basket.phone, basket, project.id);
        console.log("Created order")
        if (!orderResponse?.referenceId) {
          throw new Error('CREATE_ORDER_ERROR');
        }
        
        setOrderReferenceId(orderResponse.referenceId);
        await handlePaymentFlow(orderResponse.referenceId, selectedOption);
      } else {
        await handlePaymentFlow(orderReferenceId, selectedOption);
      }
    } catch (error) {
      console.log("Error", error)
      setError(error.message);
    } finally {
      isSubmitting.current = false;
      setIsProcessing(false);
      dispatch(setLoading(false));
    }
  };

  const handlePaymentFlow = async (referenceId, selectedOption) => {
    if (selectedOption === "swish") {
      navigate(`/payment/swish/${referenceId}`);
      return;
    }

    dispatch(setLoading(true));
    
    const paymentMethodsMap = {
      'vipps': ['vipps',],
      'applepay': ['applepay'],
      'card': ['visa', 'mastercard']
    };

    const paymentMethods = paymentMethodsMap[selectedOption];
    if (!paymentMethods) {
      throw new Error('INVALID_PAYMENT_METHOD');
    }

    const response = await startNetsPayment(referenceId, project.currency, paymentMethods);
    
    if (!response?.netsIntegrationResponse?.paymentId) {
      throw new Error('NETS_ERROR');
    }

    navigate(
      `/payment/nets/${response.netsIntegrationResponse.paymentId}/${referenceId}/${project.currency}`
    );
  };

  return {
    handlePayment,
    isProcessing,
    error,
    resetError: () => setError(null),
    orderReferenceId
  };
};